'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00245 from "./presto.-Audit-View$$anon$5.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024 from "./presto.-Audit-View$-Audit-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$4() {
  this.aBk = null;
  this.aBc = null;
  this.aBd = false;
  this.aBl = null;
  this.aBm = false;
  this.aBp = null;
  this.aBi = null;
  this.aBj = false;
  this.aBe = null;
  this.aBf = false;
  this.aBg = null;
  this.aBh = false;
  this.aBn = false;
  this.aBo = false;
  this.aBk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aBp = "AuditName";
}
export { $c_Lpresto_AuditView$$anon$4 as $c_Lpresto_AuditView$$anon$4 };
$p = $c_Lpresto_AuditView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$4;
/** @constructor */
function $h_Lpresto_AuditView$$anon$4() {
}
export { $h_Lpresto_AuditView$$anon$4 as $h_Lpresto_AuditView$$anon$4 };
$h_Lpresto_AuditView$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aBk;
});
$p.M = (function() {
  if ((!this.aBd)) {
    this.aBc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aBd = true;
  }
  return this.aBc;
});
$p.O = (function() {
  if ((!this.aBm)) {
    this.aBl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aBm = true;
  }
  return this.aBl;
});
$p.E = (function() {
  return this.aBp;
});
$p.t = (function() {
  if ((!this.aBj)) {
    this.aBi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aBj = true;
  }
  return this.aBi;
});
$p.N = (function() {
  if ((!this.aBf)) {
    this.aBe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aBf = true;
  }
  return this.aBe;
});
$p.Q = (function() {
  if ((!this.aBh)) {
    this.aBg = new $j_presto$002e$002dAudit$002dView$0024$0024anon$00245.$c_Lpresto_AuditView$$anon$5();
    this.aBh = true;
  }
  return this.aBg;
});
$p.v = (function() {
  if ((!this.aBo)) {
    this.aBn = false;
    this.aBo = true;
  }
  return this.aBn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.cFq(p)))($j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024.$m_Lpresto_AuditView$AuditName$())));
});
var $d_Lpresto_AuditView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$4, "presto.AuditView$$anon$4", ({
  Ey: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AuditView$$anon$4 as $d_Lpresto_AuditView$$anon$4 };
//# sourceMappingURL=presto.-Audit-View$$anon$4.js.map
